import { Loader2 } from 'lucide-react'
import { EventFeed } from '@/components/events/EventFeed'
import { useDefaultEventCategory } from '@/hooks/useDefaultEventCategory'

// The Events page is the unfiltered events feed. The feed itself lives in
// EventFeed so the Favourites page (#122) can reuse it with favorite=true.
//
// #248: a bare /events opens on the fleet-wide default tab a super admin chooses.
// The feed is mounted only once that value is known: the URL hook canonicalises
// against the schema default on mount, so mounting early would bake a wrong
// default in. Camera links carry their own ?category= (items 236/238) and win.
export function EventsPage() {
  const { category } = useDefaultEventCategory()
  if (!category) {
    return (
      <div className="flex justify-center py-16" role="status" aria-busy="true">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    )
  }
  return <EventFeed defaultCategory={category} />
}
